const DataSourceState = {
  Loading: 'Loading',
  Done: 'Done',
  Error: 'Error',
};

export { DataSourceState };
